<template>
  <div class="data-management-contents">
    <div>
      <b-row>
        <b-colxx xxs="12">
          <div class="separator mb-5"></div>
        </b-colxx>
      </b-row>
      <!-- Study dropdown groups -->
      <b-row>
        <b-colxx xxs="12" class="mb-4 pl-0">
          <header-drop-down-filter
            :leftHeaderText="leftHeaderTextValue"
            :sites="getAllSiteList"
            :countries="countryList"
            :callApiCompleted="callApiCompleted"
            :checkedSitesApply="sitesSelected == 'all' ? allSitesList : sitesSelected"
            :checkedCountriesApply="countrySelected == 'all' ? countryList : countrySelected"
            :exportBtn="true"
            :participantsBtn="true"
            @onApplyCountry="onFilterCountry"
            @onApplySites="onFilterSites"
            @onApplyParticipants="onFilterParticipants"
            @onApplyFpi="filter"
            @onFetchedParticipants="fetchedParticipants"
            :todayDate="todaysDate"
            :dataPicker="dataPicker"
            @onApplyRangeMonth="getRangeMonth"
            v-if="studyData"
            :zoomGraphValue="zoomGraphValue"
            :specificSiteId="specificSiteId"
            :toggleFeatures="toggleFeatures"
            :studyData="studyData"
          ></header-drop-down-filter>
        </b-colxx>
      </b-row>

      <div v-if="zoomGraphValue" @click="zoomGraphValue = ''" class="mb-10 color_4c8ce4 expand-back">
        <i class="fa fa-caret-left" aria-hidden="true"></i>
        Back
      </div>
      <!-- COMMENT BELOW CODE. DISABLE UNTIL NEXT RELEASE -->
      <b-row class="pb-10" v-if="complianceWidgets" v-show="zoomGraphValue === '' || zoomGraphValue === 'study-completion-data-table' || zoomGraphValue === 'study-completion-data-table'">
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'study-completion-data-table'" :class="zoomGraphValue === 'study-completion-data-table' ? 'col-xl-12 study-completion-data-table-zoom' : 'col-xl-12'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 1s">
          <NewStudyCompletionCard
            titleChart="Scheduled Activity Completion by Participants"
            :specificSiteId="specificSiteId"
            :zoomGraphValue="zoomGraphValue"
            @zoomEnabled="zoomGraphValue = 'study-completion-data-table'"
            @zoomDisabled="zoomGraphValue = ''"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :countryList="countryList"
            :allSiteList="getAllSiteList"
            :dataSources="rawData"
            :siteListInParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.rawData"
            @onScrollTable="onScrollTable"
            :participantsSelected="participantsSelected"
            :filterDate="[fromDate, toDate]"
            :onFilterDate="onFilterDate"
            data-testid="scheduled-activity-completion"
          />
        </b-colxx>
      </b-row>

      <b-row class="pb-10" v-if="complianceWidgets" v-show="zoomGraphValue === '' || zoomGraphValue === 'activity-completion-metric'">
        <b-colxx v-show="zoomGraphValue === '' || zoomGraphValue === 'activity-completion-metric'" :class="zoomGraphValue === 'activity-completion-metric' ? 'col-xl-12 activity-completion-metric-zoom' : 'col-xl-12'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 1s">
          <ActivityCompletionMetrics
            :siteListInParticipants="siteListInParticipants"
            :collectionMetricsRaw="overallCollectionMetricRaw"
            :filterTriggered="filterTriggered"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :specificSiteId="specificSiteId"
            :customType="'scrollstackedcolumn2d'"
            :zoomGraphValue="zoomGraphValue"
            :listParticipants="siteListInParticipants"
            :dataLoaded="dataLoaded.overallCollectionMetricRaw"
            v-on:zoomEnabled="zoomGraphValue = 'activity-completion-metric'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            titleChart="Activity Completion Metrics"
            data-testid="activity-completion-metrics"
          >
          </ActivityCompletionMetrics>
        </b-colxx>
      </b-row>
      <b-row class="pb-10" v-show="zoomGraphValue === '' || zoomGraphValue === 'Discontinuation-Activity'">
        <b-colxx v-show="(zoomGraphValue === '' || zoomGraphValue === 'Discontinuation-Activity')" :class="zoomGraphValue === 'Discontinuation-Activity' ? 'col-xl-12 Discontinuation-Activity-zoom' : 'col-xl-12'" lg="12" md="12" class="pl-0 pb-6" style="transition-duration: 1s">
          <DiscontinuationActivity
            titleChart="Discontinuation Activity"
            downloadId="Discontinuation-Activity"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'Discontinuation-Activity'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :rawData="this.sitesiteDiscontinuationActivity"
            :participantsSelected="participantsSelected"
            data-testid="discontinuation-activity-chart"
          />
        </b-colxx>
      </b-row>
      <b-row>
        <b-colxx :class="zoomGraphValue === 'Other-Discontinuation-Reasons' ? 'col-xl-12 Other-Discontinuation-Reasons-zoom' : 'col-xl-6'" v-show="(zoomGraphValue === '' || zoomGraphValue === 'Other-Discontinuation-Reasons')" lg="12" md="12" class="pl-0 pb-10">
          <OtherDiscontinuationReasons
            titleChart="Other Discontinuation Reasons"
            downloadId="Other-Discontinuation-Reasons"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'Other-Discontinuation-Reasons'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :rawData="siteOtherDiscontinuationReasons"
            :participantsSelected="participantsSelected"
            data-testid="other-discontinuation-reasons-chart"
          />
        </b-colxx>
        <b-colxx :class="zoomGraphValue === 'participant-study-progress' ? 'col-xl-12 participant-study-progress-zoom' : 'col-xl-6'" v-show="zoomGraphValue === '' || zoomGraphValue === 'participant-study-progress'" lg="12" md="12" class="pl-0 pb-10">
          <ParticipantStudyProgress
            titleChart="Participant Study Progress"
            downloadId="participant-study-progress"
            :zoomGraphValue="zoomGraphValue"
            v-on:zoomEnabled="zoomGraphValue = 'participant-study-progress'"
            v-on:zoomDisabled="zoomGraphValue = ''"
            :specificSiteId="specificSiteId"
            :countrySelected="countrySelected"
            :sitesSelected="sitesSelected"
            :rawData="siteDataPerformanceOverTimeRawData"
            :rawData1="siteDataPerformanceOverTimeRawData1"
            :participantsSelected="participantsSelected"
            data-testid="participant-study-progress-chart"
          />
        </b-colxx>
      </b-row>
    </div>
  </div>
</template>

<script>
// Below is required import in every feature
import Vue from "vue";
import _get from "lodash/get";
import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import * as utils from "../../services/visualization/utils";
import * as sc from "../../services/visualization/study-completion";
import * as srv from "../../services/visualization/data-management";
import HeaderDropDownFilter from "../form-components/header-drop-down-filter";
import ParticipantStudyProgress from "../containers/participant-study-progress";
import OtherDiscontinuationReasons from "../containers/Other-Discontinuation-Reasons";
import DiscontinuationActivity from "../containers/Discontinuation-Activity";
// Below is support fo component feature
import ActivityCompletionMetrics from "../containers/activity-completion-metrics.vue";
import NewStudyCompletionCard from "../containers/new-study-completion-card";
import * as commonHelper from "@/components/services/common-helper";

import "vue-loading-overlay/dist/vue-loading.css";

Vue.use(Loading);

export default {
  components: {
    HeaderDropDownFilter,
    ActivityCompletionMetrics,
    NewStudyCompletionCard,
    ParticipantStudyProgress,
    DiscontinuationActivity,
    OtherDiscontinuationReasons
  },
  props: {
    toggleFeatures: { type: Array, default: () => [] },
    complianceWidgets: { type: Boolean, default: false },
    studyData: { type: Object, default: null }
  },
  data() {
    return {
      rawData: null,
      siteDataPerformanceOverTimeRawData: null,
      siteDataPerformanceOverTimeRawData1: null,
      sitesiteDiscontinuationActivity: null,
      siteOtherDiscontinuationReasons: null,
      siteDataPerformanceRawData: null,
      overallCollectionMetricRaw: {},
      participants: [],
      cacheRawData: null,
      filterTriggered: false,
      callApiCompleted: null,
      dataRetentionRateRaw: null,
      // Below is required state in each feature
      zoomGraphValue: "",
      countryList: [],
      allSitesList: [],
      participantList: [],
      sitesSelected: ["all"],
      countrySelected: "all",
      participantsSelected: ["all"],
      loader: null,
      leftHeaderTextValue: "Retention Dashboard",
      specificSiteId: null,
      siteListInParticipants: [],
      monthSelected: [],
      fromDate: null,
      toDate: null,
      firstFromDate: null,
      firstToDate: null,
      dataPicker: [],
      todaysDate: "",
      isLoading: true,
      dataLoaded: {},
      tmpCountries: [],
      tmpSites: [],
      tmpParticipants: [],
      limit: 10,
      page: 1,
      activityLimit: 30,
      activityPage: 1,
      onFilterDate: false,
      filterTriggerBy: "",
      bufferPage: 0,
      horizontalScrollCount: 1,
      allApiCountries: [],
      allApiSites: [],
      dashboardDataLoaded: {
        completionEndpoint: false,
        discontinuationActivity: false,
        otherDiscontinuationReasons: false,
        siteDataPerformanceOverTime: false,
        milestoneParticipantStudyProgress: false,
        activityCompletionMetrics: false
      }
    };
  },

  methods: {
    fetchedParticipants(payload) {
      this.siteListInParticipants = payload;
    },
    getCompletionEndpoint(filterBy = null) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };

        if(filterBy == "date"){
          params.fromDate = this.fromDate;
          params.toDate = this.toDate;
        }

        if (filterBy === "participant" && this.participantsSelected[0] !== "all") {
          params.participantsIds = utils.convertArrToString(this.participantsSelected);
        }

        if (this.specificSiteId && this.specificSiteId.length > 0) {
          params.siteId = this.specificSiteId[0];
        }
        else if(this.sitesSelected && this.sitesSelected.length > 0 && filterBy == "scroll"){
          let siteIdArray = this.getSiteIdsByName(this.sitesSelected);
          params.siteId = utils.convertArrToString(siteIdArray);
        }

        params.limit = this.limit;
        params.page = this.page;
        params.activityLimit = this.activityLimit;
        params.activityPage = this.activityPage;

        if (this.participantProgressData && this.participantProgressData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
          const result = this.participantProgressData.body;
          response = _get(result, "data", null);
          this.setParticipantCompletionVisData(response);
          this.dashboardDataLoaded.completionEndpoint = true;
          return response;
        } else {
          this.$api.getParticipantCompletionVisData(params).then(data => {
            if (data.ok) {
              this.dashboardDataLoaded.completionEndpoint = true;
              const result = data.body;
              response = _get(result, "data", null);
              if(params.activityPage == 1 && params.page == 1){
                this.$store.dispatch("saveParticipantProgressData", data);
                this.$store.dispatch("saveStudyId", this.studyId);
              }
              this.setParticipantCompletionVisData(response, filterBy);
              return response;
            }
          })
        }
      }
    },
    getActivityCompletionMetrics(filterBy) {
      if (this.complianceWidgets) {
        this.isLoading = true;
        let response = null;
        const params = {
          studyId: this.studyId
        };
        try {
          if (this.fromDate) {
            params.fromDate = this.fromDate;
            params.toDate = this.toDate;
          }

          if (this.participantsSelected && this.participantsSelected[0] !== "all") {
            params.participantsIds = utils.convertArrToString(this.participantsSelected);
          }

          if (this.specificSiteId && this.specificSiteId.length > 0) {
            params.siteId = this.specificSiteId[0];
          }
          if (this.overallCollectionData && this.overallCollectionData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
            const result = this.overallCollectionData.body;
            if (result.data && "activities" in result.data) {
              response = result.data.activities;
              this.setOverallColectionEndpointData(response);
            }
            this.dashboardDataLoaded.activityCompletionMetrics = true;
          } else {
              this.$api.getOverallColectionEndpoint(params).then(data =>{
              if (data.ok) {
                this.dashboardDataLoaded.activityCompletionMetrics = true;
                const result = data.body;
                this.$store.dispatch("saveOverallCollectionData", data);
                this.$store.dispatch("saveStudyId", this.studyId);
                if (result.data && "activities" in result.data) {
                  response = result.data.activities;
                  this.setOverallColectionEndpointData(response);
                }
              }
            })
          }
        } catch (err) {}
        this.isLoading = false;
        return response;
      }
    },
    async callApi(turnOffGlobalLoader = false, filterBy) {
      let apiPromises = [];
      let newCountries = [];
      let newSites = [];

      if (["mounted", "date"].includes(filterBy)) {
        this.getCompletionEndpoint(filterBy);
        this.getDiscontinuationActivity(filterBy);
        this.getOtherDiscontinuationReasons(filterBy);
        this.getSiteDataPerformanceOverTime(filterBy);
        this.getmilestoneParticipantStudyProgress(filterBy);
        this.getActivityCompletionMetrics(filterBy);
      }

      if (["participant"].includes(filterBy)) {
        apiPromises = apiPromises.concat([
          // TODO - Need to Modify when Participant filter is Enabled
          this.getCompletionEndpoint(filterBy).then(response => {
            if (response) {
              const countries = utils.getCountries(response.locations);
              const sites = utils.getSites(response.locations, countries);

              newCountries = newCountries.concat(countries);
              newSites = newSites.concat(sites);
              this.rawData = response;
              this.cacheRawData = response;
              
            }
          }),
          this.getSiteDataPerformanceOverTime(filterBy).then(raws => {
            if (raws) {
              this.dataLoaded.siteDataPerformanceOverTime = false;
              const countries = srv.getCountries(raws.countries);
              const sites = srv.getSites(raws.countries, countries);
              newCountries = newCountries.concat(countries);
              newSites = newSites.concat(sites);
              this.siteDataPerformanceOverTimeRawData = raws;
              this.dataLoaded.siteDataPerformanceOverTime = true;
            }
          }),
          this.getDiscontinuationActivity(filterBy).then(raws => {
            this.dataLoaded.sitesiteDiscontinuationActivity = false;
            this.sitesiteDiscontinuationActivity = raws.countries;
            const countries = srv.getCountries(raws.countries);
            const sites = srv.getSites(raws.countries, countries);
            newCountries = newCountries.concat(countries);
            newSites = newSites.concat(sites);
            this.dataLoaded.sitesiteDiscontinuationActivity = true;
          }),
          this.getOtherDiscontinuationReasons(filterBy).then(raws => {
            this.dataLoaded.siteOtherDiscontinuationReasons = false;
            const countries = srv.getCountries(raws.countries);
            const sites = srv.getSites(raws.countries, countries);
            newCountries = newCountries.concat(countries);
            newSites = newSites.concat(sites);
            this.siteOtherDiscontinuationReasons = raws.countries;
            this.dataLoaded.siteOtherDiscontinuationReasons = true;
          }),
          this.getActivityCompletionMetrics(filterBy).then(raws => {
            if (raws) {
              const countries = srv.getCountriesByActivities(raws);
              const choosenCountries = countries;
              const sites = srv.getSiteByActivities(raws, choosenCountries);

              newCountries = newCountries.concat(countries);
              newSites = newSites.concat(sites);
              this.overallCollectionMetricRaw = raws;
              this.dataLoaded.overallCollectionMetricRaw = true;
            }
          })
        ]);
      }
      await Promise.all(apiPromises);
      if (["participant"].includes(filterBy)) {
        this.tmpCountries = newCountries;
        this.tmpSites = newSites;
      }
      this.callApiCompleted = true;
      if (turnOffGlobalLoader) {
        await this.turnOffGlobalLoader();
      }
    },

    // This required function in every feature
    onFilterCountry(payload) {
      this.limit = this.page * this.limit;
      this.activityLimit = this.activityPage * this.activityLimit;
      this.activityPage = 1;
      this.page = 1;
      this.filter("country", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },

    // This required function in every feature
    onFilterSites(payload) {
      this.limit = this.page * this.limit;
      this.activityLimit = this.activityPage * this.activityLimit;
      this.activityPage = 1;
      this.page = 1;
      this.filter("site", payload.isCheckAll ? "all" : payload.checked, payload.detailSite);
    },

    // This required function in every feature
    onFilterParticipants(payload) {
      if (payload.isCheckAll) {
        this.sitesSelected = this.allSitesList;
      }
      const oldLimit = this.limit;
      this.limit = !payload.isCheckAll ? this.limit : 1000;
      this.activityLimit = this.activityPage * this.activityLimit;
      this.activityPage = 1;
      this.page = 1;
      this.filter("participant", payload.isCheckAll ? "all" : payload);
      this.limit = oldLimit;
    },

    // This required function in every feature
    getRangeMonth(payload) {
      this.limit = !payload.isCheckAll ? this.limit : 1000;
      this.activityLimit = this.activityPage * this.activityLimit;
      this.activityPage = 1;
      this.page = 1;
      this.onFilterDate = !this.onFilterDate;
      this.filter("date", payload);
    },

    // This required function in every feature
    async filter(triggerBy, filterValue) {
      switch (triggerBy) {
        case "country": {
          const countrySelected = filterValue === "all" ? this.countryList : filterValue;
          const participantProgressData = this.rawData ? this.rawData.locations : {};
          const participantStudyProgression = this.siteDataPerformanceOverTimeRawData ? this.siteDataPerformanceOverTimeRawData.countries : {};
          const payload = {
            activities: {
              ...this.overallCollectionMetricRaw
            },
            countries: {
              ...this.sitesiteDiscontinuationActivity,
              ...participantProgressData,
              ...participantStudyProgression
            }
          };
          const allSitesSelected = [...srv.getSitesByGeneralAndActivities(payload, countrySelected), ...utils.getAllSitesWhenFilteringCountry(payload, countrySelected)];
          this.countrySelected = filterValue === "all" ? ["all"] : filterValue;
          const filteredSites = [...new Set(allSitesSelected)];
          this.sitesSelected = filterValue === "all" ? ["all"] : filteredSites;

          const sitesSelected = this.sitesSelected[0] === "all" ? filteredSites : this.sitesSelected;
          if (this.rawData) {
            this.participantList = _.uniq(sc.filterParticipantListFromProgressResult(this.rawData.locations, countrySelected, sitesSelected, this.participants));
          }
          this.participantsSelected = filterValue === "all" ? ["all"] : this.participantsSelected;
          break;
        }
        case "site": {
          this.sitesSelected = filterValue === "all" ? ["all"] : filterValue;
          this.countrySelected = utils.getCountryWhenSiteFilterApply(filterValue, this.countrySelected, this.sitesData, this.countryList);
          const countrySelected = this.countrySelected[0] === "all" ? this.countryList : this.countrySelected;
          const sitesSelected = this.sitesSelected[0] === "all" ? this.allSitesList : this.sitesSelected;
          if (this.rawData) {
            this.participantList = _.uniq(sc.filterParticipantListFromProgressResult(this.rawData.locations, countrySelected, sitesSelected, this.participants));
          }
          this.participantsSelected = filterValue === "all" ? ["all"] : this.participantsSelected;
          break;
        }
        case "date": {
          this.monthSelected = filterValue;
          this.fromDate = this.fromDate = filterValue[0].value;
          this.toDate = this.toDate = filterValue[1].value;

          if (this.fromDate === this.firstFromDate && this.toDate === this.firstToDate) {
            this.fromDate = null;
            this.toDate = null; // Reset date to default value
          }
          this.filterTriggerBy = "date";
          break;
        }
        case "participant": {
          this.participantsSelected = filterValue === "all" ? ["all"] : filterValue.checkedParticipants;
          this.filterTriggerBy = "participant";
          if (this.participantsSelected && this.participantsSelected.length === 0) {
            this.setToEmptyData();
            return;
          }
        }
      }

      await this.callApi(true, triggerBy);
      this.filterTriggered = !this.filterTriggered;
    },
    async prepareDatePicker() {
      const d = new Date();
      this.todaysDate = moment.utc(d).format("DD MMM YYYY");
      const studyData = this.studyData;
      const studyStartDate = studyData.studyStartDate;
      const datePicker = [];
      const tmpPicker = [];
      for (let m = moment(studyStartDate); m.diff(moment(), "months") <= 0; m.add(1, "months")) {
        datePicker.push(m.format("MMM YYYY"));
        tmpPicker.push(m.format("YYYY-MM-DD"));
      }
      this.dataPicker = datePicker;
      const firstMonth = this.dataPicker[0];
      const lastMonth = this.dataPicker[this.dataPicker.length - 1];
      this.monthSelected = [firstMonth, lastMonth];
    },
    // This required function in every feature
    setToEmptyData() {
      this.rawData = null;
      this.overallCollectionMetricRaw = null;
    },

    onScrollTable(scrollDirection) {
      // Fetch pagination data when scroll table
      if (scrollDirection === "vertical") {
        this.page += 1;
        this.activityPage = 1;
        this.activityLimit = this.horizontalScrollCount * 30;
      } else if (scrollDirection === "horizontal") {
        this.bufferPage += 1;
        this.horizontalScrollCount += 1;
        if (this.activityPage !== 1) {
          this.activityPage += 1;
        } else {
          this.activityPage += this.bufferPage;
        }
        this.limit = this.page * this.limit;
        this.page = 1;
        this.activityLimit = 30;
      }
      let response = this.getCompletionEndpoint("scroll");
      if (response && response.locations) {
        this.rawData = response;
        this.cacheRawData = response;
      }
    },

    getDiscontinuationActivity(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };
      const body = {};

      if (this.fromDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }
      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        body.siteId = this.specificSiteId[0];
      }
      if (this.discontinuationActivity && this.discontinuationActivity.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
        const result = this.discontinuationActivity.body;
        response = result.data;
        this.setDiscontinuationReasonsData(response);
        this.dashboardDataLoaded.discontinuationActivity = true;
      } else {
        this.$api.DiscontinuationReasons(params, body).then(data =>{
          if (data.ok) {
          this.dashboardDataLoaded.discontinuationActivity = true;
          const result = data.body;
          if (result.data) {
            response = result.data;
            this.setDiscontinuationReasonsData(response);
          }
          this.$store.dispatch("saveDiscontinuationActivity",data);
          this.$store.dispatch("saveStudyId",this.studyId);
          }
        })
      }
      this.isLoading = false;
      return response;
    },
    getOtherDiscontinuationReasons(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };
      const body = {};

      if (this.fromDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }
      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        body.siteId = this.specificSiteId[0];
      }
      if (this.otherDiscontinuationReasons && this.otherDiscontinuationReasons.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
        const result = this.otherDiscontinuationReasons.body;
        response = result.data;
        this.setOtherDiscontinuationReasonsData(response);
        this.dashboardDataLoaded.otherDiscontinuationReasons = true;
      } else {
        this.$api.otherDiscontinuationReasons(params, body).then(data=>{
          if (data.ok) {
            this.dashboardDataLoaded.otherDiscontinuationReasons = true;
            const result = data.body;
            this.$store.dispatch("saveOtherDiscontinuationReasons",data);
            this.$store.dispatch("saveStudyId",this.studyId);
            if (result.data) {
              response = result.data;
              this.setOtherDiscontinuationReasonsData(response);
            }
          }
        })
      }
      this.isLoading = false;
      return response;
    },
    getSiteDataPerformanceOverTime(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };
      const body = {};

      if (this.fromDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }
      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        body.siteId = this.specificSiteId[0];
      }
      if (this.participantStudyProgression && this.participantStudyProgression.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
        const result = this.participantStudyProgression.body;
        response = result.data;
        this.setSiteDataPerformanceData(response);
        this.dashboardDataLoaded.siteDataPerformanceOverTime = true;
      } else {
        this.$api.SiteDataPerformancedata(params, body).then(data =>{
          if (data.ok) {
            this.dashboardDataLoaded.siteDataPerformanceOverTime = true;
            const result = data.body;
            this.$store.dispatch("saveParticipantStudyProgression",data);
            this.$store.dispatch("saveStudyId",this.studyId);
            if (result.data) {
              response = result.data;
              this.setSiteDataPerformanceData(response);
            }
          }
        })
      }
      this.isLoading = false;
      return response;
    },
    getmilestoneParticipantStudyProgress(filterBy) {
      this.isLoading = true;
      let response = null;
      const params = {
        studyId: this.studyId
      };
      const body = {};

      if (this.fromDate) {
        body.fromDate = this.fromDate;
        body.toDate = this.toDate;
      }
      if (this.participantsSelected && this.participantsSelected[0] !== "all") {
        body.participantsIds = this.participantsSelected;
      }

      if (this.specificSiteId && this.specificSiteId.length > 0) {
        body.siteId = this.specificSiteId[0];
      }
      if (this.milestonesData && this.milestonesData.body && this.checkCurrentSiteOrStudy && filterBy == "mounted") {
        const result = this.milestonesData.body;
        response = result.data;
        this.siteDataPerformanceOverTimeRawData1 = response;
        this.dashboardDataLoaded.milestoneParticipantStudyProgress = true;
      } else {
        this.$api.SiteDataPerformance1(params).then(data =>{
          if (data.ok) {
            this.dashboardDataLoaded.milestoneParticipantStudyProgress = true;
            const result = data.body;
            this.$store.dispatch("saveMiletonesData",data);
            this.$store.dispatch("saveStudyId",this.studyId);
            if (result.data) {
              response = result.data;
              this.siteDataPerformanceOverTimeRawData1 = response;
            }
          }
        })
      }
      this.isLoading = false;
      return response;
    },
    async turnOffGlobalLoader() {
      const query = Object.assign({}, this.$route.query);
      delete query.automatic_off_loader;
      this.$router.replace({ query });
      this.$store.commit("SHOW_LOADER", false);
      setTimeout(() => {
        this.dataLoaded["rawData"] = true;
      }, 500);
    },
    setParticipantCompletionVisData(response, filterBy){
      if (response) {
        this.rawData = null;
        this.cacheRawData = null;
        if(filterBy !== "scroll"){
          const countries = utils.getCountries(response.locations);
          const sites = utils.getSites(response.locations, countries);
          this.allApiCountries = this.allApiCountries.concat(countries);
          this.tmpCountries = this.tmpCountries.concat(countries);
          this.tmpSites = this.tmpSites.concat(sites);
        }
        this.rawData = response;
        this.cacheRawData = response;
      }
    },
    setDiscontinuationReasonsData(raws){
      if(raws){
        this.sitesiteDiscontinuationActivity = raws.countries;
        this.dataLoaded.sitesiteDiscontinuationActivity = false;
        const countries = srv.getCountries(raws.countries);
        const sites = srv.getSites(raws.countries, countries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.dataLoaded.sitesiteDiscontinuationActivity = true;
      }
    },
    setOtherDiscontinuationReasonsData(raws){
      if(raws){
        this.siteOtherDiscontinuationReasons = raws.countries;
        this.dataLoaded.siteOtherDiscontinuationReasons = false;
        const countries = srv.getCountries(raws.countries);
        const sites = srv.getSites(raws.countries, countries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.dataLoaded.siteOtherDiscontinuationReasons = true;
      }
    },
    setSiteDataPerformanceData(raws){
      if (raws) {
        this.siteDataPerformanceOverTimeRawData = raws;
        this.dataLoaded.siteDataPerformanceOverTime = false;
        const countries = srv.getCountries(raws.countries);
        const sites = srv.getSites(raws.countries, countries);
        this.allApiCountries = this.allApiCountries.concat(countries);
        this.allApiSites = this.allApiSites.concat(sites);
        this.tmpCountries = this.tmpCountries.concat(this.allApiCountries);
        this.tmpSites = this.tmpSites.concat(this.allApiSites);
        this.dataLoaded.siteDataPerformanceOverTime = true;
      }
    },
    setOverallColectionEndpointData(raws){
      if (raws) {
        const countries = srv.getCountriesByActivities(raws);
        const choosenCountries = countries;
        const sites = srv.getSiteByActivities(raws, choosenCountries);
        this.tmpCountries = this.tmpCountries.concat(countries);
        this.tmpSites = this.tmpSites.concat(sites);
        this.overallCollectionMetricRaw = raws;
        this.dataLoaded.overallCollectionMetricRaw = true;
      }
    },
    getSiteIdsByName(siteNameArray) {
      let filtertedSitesData = this.sitesData.filter(site=>{
        return siteNameArray.includes(site.name);
      });
      let selectedSiteIds = Array.from(Object.values(filtertedSitesData), site => site.id);
      return selectedSiteIds;
    }
  },

  computed: {
    ...mapGetters(["user", "studyIdValue", "overallCollectionData", "participantProgressData", "discontinuationActivity", "otherDiscontinuationReasons", "participantStudyProgression", "milestonesData", "sitesData", "selectedSiteId"]),
    getSiteId() {
      return localStorage.getItem("selectedSite");
    },
    isSiteRole() {
      return commonHelper.isSiteUser(this.user.userRole);
    },
    checkCurrentSiteOrStudy() {
      return this.studyIdValue === this.studyId && (!this.isSiteRole || (this.isSiteRole && this.getSiteId === this.selectedSiteId));
    },
    getAllSiteList(){
      if(this.dashboardDataLoaded.completionEndpoint && this.dashboardDataLoaded.discontinuationActivity && this.dashboardDataLoaded.otherDiscontinuationReasons && this.dashboardDataLoaded.siteDataPerformanceOverTime && this.dashboardDataLoaded.milestoneParticipantStudyProgress && this.dashboardDataLoaded.activityCompletionMetrics){
        return this.allSitesList;
      }
    } 
  },

  watch: {
    tmpCountries: function(val) {
      const allCountries = _.uniq(val);
      this.countryList = _.orderBy(Array.from(allCountries), [country => country.toLowerCase()]);
    },
    tmpSites: function(val) {
      const allSites = _.uniq(val);
      this.allSitesList = _.orderBy(Array.from(allSites), [site => site.toLowerCase()]);
    },
    tmpParticipants: function(val) {
      this.participantsSelected = val;
    }
  },

  async mounted() {
    this.$router.push({ query: { automatic_off_loader: false } });
    this.studyId = this.$route.params.studyId;
    await this.prepareDatePicker();

    this.specificSiteId = _get(this.user, "siteIds", []);
    await this.callApi(true, "mounted");
  }
};
</script>
